import { SvgIcon, SvgIconProps } from "@mui/material";
import type { JSX } from "react";

export const SupportIcon = (props: SvgIconProps): JSX.Element => (
  <SvgIcon viewBox="0 0 21 20" fill="none" {...props}>
    <path
      d="M3.72339 7.12869C3.92607 3.70241 6.79256 1 10.2188 1C13.6162 1 16.4826 3.67346 16.7143 7.08043"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      fill="none"
    />

    <path
      d="M4.51476 7.75649C4.79465 8.02673 4.77535 8.44174 4.7657 8.52861V13.8176C4.7657 13.9334 4.79465 14.3002 4.54372 14.5318C4.39894 14.6766 4.16731 14.7538 3.71369 14.7152C3.26972 14.6766 1.99573 14.5801 1.34908 13.5956C1.06918 13.171 1.06918 12.505 1.07884 11.2021C1.07884 9.97633 1.08849 9.35863 1.34908 8.90501C1.90886 7.91091 3.01878 7.54416 3.72334 7.52485C4.25417 7.50555 4.4665 7.68893 4.51476 7.74684V7.75649Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      fill="none"
    />

    <path
      d="M15.8553 7.75649C15.5754 8.02673 15.5947 8.44174 15.6044 8.52861V13.8176C15.6044 13.9334 15.5754 14.3002 15.8263 14.5318C15.9711 14.6766 16.2027 14.7538 16.6564 14.7152C17.1003 14.6766 18.3743 14.5801 19.021 13.5956C19.3009 13.171 19.3009 12.505 19.2912 11.2021C19.2912 9.97633 19.2816 9.35863 19.021 8.90501C18.4612 7.91091 17.3513 7.54416 16.6467 7.52485C16.1159 7.50555 15.9035 7.68893 15.8553 7.74684V7.75649Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      fill="none"
    />

    <path
      d="M16.859 15.0332C16.8686 15.2745 16.8879 16.0177 16.3957 16.7415C16.2896 16.8959 15.8649 17.5136 15.1217 17.7356C14.7839 17.8418 14.3303 17.8418 13.4327 17.8514C13.2879 17.8514 13.1625 17.8514 13.0853 17.8514"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      fill="none"
    />

    <path
      d="M11.4638 16.7031H10.1609C9.52654 16.7031 9.01233 17.2173 9.01233 17.8516C9.01233 18.486 9.52654 19.0002 10.1609 19.0002H11.4638C12.0981 19.0002 12.6123 18.486 12.6123 17.8516C12.6123 17.2173 12.0981 16.7031 11.4638 16.7031Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      fill="none"
    />

    <path
      d="M12.622 8.45117V9.34876"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />

    <path
      d="M7.79633 8.45117V9.34876"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />

    <path
      d="M7.90247 12.8619C8.19201 13.0549 9.07029 13.5858 10.2864 13.5375C11.4446 13.4893 12.2456 12.9584 12.5255 12.7461"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      fill="none"
    />
  </SvgIcon>
);
